import { Routes, RouterModule } from "@angular/router";
import { NgModule } from "@angular/core";
import { CustomLayoutComponent } from "../layout/custom-layout/custom-layout.component";
import { InternationalActivitiesUsermanualsComponent } from "./international-activities-usermanuals.component";

const routes: Routes = [
    {
        path: 'international-activities-usermanuals/:linea',
        component: CustomLayoutComponent,
        children: [
          { path: '', component: InternationalActivitiesUsermanualsComponent },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class InternationalActivitiesUsermanualsRoutingModule { }
